<template>
    <v-form class="form" @submit.prevent="validate">
        <div class="form__row">
            <div class="form__title">
                {{ $t('auth.form.email_title') }}
            </div>
            <div class="form__fields">
                <v-text-field
                        v-model="email"
                        v-validate="'required|email'"
                        type="email"
                        :error-messages="errors.collect('email')"
                        name="email"
                        class="input-main"
                        outline
                        single-line
                >
                </v-text-field>
                <svg class="icon icon__email" width="17" height="13" viewBox="0 0 17 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path class="icon__path" d="M2.03333 2.79454L1.21078 2.1001V3.17659V11.0181C1.21078 11.285 1.3659 11.4757 1.50564 11.579C1.65048 11.6861 1.83208 11.7452 2.01775 11.7452H14.9823C15.168 11.7452 15.3495 11.6861 15.4943 11.5791C15.6339 11.4759 15.7892 11.2854 15.7894 11.0186V11.0182V3.17642V2.09993L14.9668 2.79436L9.10303 7.74483C9.07299 7.77019 9.0343 7.78432 8.99507 7.78433C8.99507 7.78433 8.99506 7.78433 8.99505 7.78433L8.00479 7.78429H8.00477C7.96537 7.78429 7.92682 7.77015 7.89691 7.74489L7.89684 7.74483L2.03333 2.79454ZM8.17684 6.96721L8.50002 7.24098L8.82321 6.96721L14.5262 2.13615L15.5668 1.25464H14.203H2.79702H1.43322L2.47384 2.13615L8.17684 6.96721ZM2.01775 0.543945H14.9823C15.838 0.543945 16.5 1.20822 16.5 1.98166V11.0181C16.5 11.7916 15.838 12.4559 14.9823 12.4559H2.01775C1.16205 12.4559 0.5 11.7916 0.5 11.0181V1.98166C0.5 1.20824 1.16205 0.543945 2.01775 0.543945Z" />
                </svg>
            </div>
        </div>
        <div class="form__row">
            <div class="form__title">
                {{ $t('auth.form.password_title') }}
            </div>
            <div class="form__fields">
                <v-text-field
                        v-model="password"
                        :type="passwordType"
                        name="password"
                        :class="reverseIcon"
                        outline
                        single-line
                        class="input-main"
                ></v-text-field>
                <svg class="icon icon__password" width="15" height="19" viewBox="0 0 15 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path class="icon__path" d="M12.5547 7.14219H11.4581V4.51189C11.4581 2.51824 9.80274 0.9 7.77221 0.9C5.74168 0.9 4.08627 2.51824 4.08627 4.51189V7.14219H2.99219C1.83847 7.14219 0.9 8.08065 0.9 9.23438V16.0078C0.9 17.1615 1.83847 18.1 2.99219 18.1H12.5547C13.7084 18.1 14.6469 17.1615 14.6469 16.0078V9.23438C14.6469 8.08065 13.7084 7.14219 12.5547 7.14219ZM5.6144 4.51189C5.6144 3.3661 6.57932 2.42813 7.77221 2.42813C8.9651 2.42813 9.93002 3.3661 9.93002 4.51189V7.14219H5.6144V4.51189ZM13.1187 16.0078C13.1187 16.3187 12.8656 16.5719 12.5547 16.5719H2.99219C2.68125 16.5719 2.42813 16.3187 2.42813 16.0078V9.23438C2.42813 8.92344 2.68125 8.67031 2.99219 8.67031H12.5547C12.8656 8.67031 13.1187 8.92344 13.1187 9.23438V16.0078Z"  stroke-width="0.2"/>
                </svg>
                <svg class="icon icon__eye" @click="reversePassType" :class="reverseIcon" width="17" height="12" viewBox="0 0 17 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path class="icon__path" d="M8.5 0.363281C4.63636 0.363281 1.33682 2.76646 0 6.15874C1.33682 9.55101 4.63636 11.9542 8.5 11.9542C12.3636 11.9542 15.6632 9.55101 17 6.15874C15.6632 2.76646 12.3636 0.363281 8.5 0.363281ZM8.5 10.0224C6.36727 10.0224 4.63636 8.29146 4.63636 6.15874C4.63636 4.02601 6.36727 2.2951 8.5 2.2951C10.6327 2.2951 12.3636 4.02601 12.3636 6.15874C12.3636 8.29146 10.6327 10.0224 8.5 10.0224ZM8.5 3.84055C7.21727 3.84055 6.18182 4.87601 6.18182 6.15874C6.18182 7.44146 7.21727 8.47692 8.5 8.47692C9.78273 8.47692 10.8182 7.44146 10.8182 6.15874C10.8182 4.87601 9.78273 3.84055 8.5 3.84055Z"/>
                </svg>
            </div>
        </div>
        <div class="form__row">
            <!--v-validate="'required|isEqual'"-->
            <!--:error-messages="errors.collect('checkbox')"-->
            <!--data-vv-name="checkbox"-->
            <v-checkbox
                    v-model="checkbox"

                    type="checkbox"
                    required
                    :label="$t('auth.form.remember_me_title')"
                    hide-details
                    color="#2C64FF"
                    :ripple="false"
            ></v-checkbox>
        </div>
        <div class="form__action">
            <button class="form__btn btn btn-blue btn-main">
                {{ $t('auth.form.sign_in_button_text') }}
            </button>
        </div>
    </v-form>
</template>

<script>

    export default {
        data() {
            return {
                email: '',
                password: '',
                checkbox: false,
                show: false
            }
        },
        methods: {
            validate () {
                const data = {
                    email: this.email,
                    password: this.password,
                    remember_me: this.checkbox
                };
                this.$validator.validateAll()
                    .then(result => {
                        if(result) this.register(data);
                    })
            },
            async register(data) {
                let {email, password, remember_me} = data;
                await this.$store
                    .dispatch("login", {email, password, remember_me})
                    .then(response => {
                        if(response && response.status === 200) {
                            this.reset();
                            this.$router.push('/')
                        }
                    })
            },
            reset(){
                this.email = this.password = '';
                this.checkbox = false;
                this.$validator.reset();
            },
            reversePassType() {
                this.show = !this.show
            },
            isEqual() {
                this.$validator.extend('isEqual', {
                    getMessage: () => this.$t('auth.form.validation.checkbox_required'),
                    validate: value => value
                });
            }
        },
        computed: {
            passwordType() {
              return this.show ? 'text': 'password'
            },
            reverseIcon() {
              return this.show ? 'is-active' : ''
            },
        },
        created() {
//            this.isEqual();
        }

    }
</script>

<style lang="sass" scoped="">
    .form
        margin-top: 58px
        width: 100%
        &__title
            color: $color--dark
            font-size: 16px
            line-height: 24px
            +reg
            margin: 8px 0
        &__btn
            width: 100%
        &__action
            margin-top: 30px
        &__fields
            position: relative
            min-height: 72px

    .icon
        position: absolute
        top: 34%
        transform: translateY(-50%)
        background-repeat: no-repeat
        z-index: 1
        &__path
            stroke: rgba(#01254E, 0.3)
            fill: rgba(#01254E, 0.3)
            +tr(fill .3s ease)
        &__email,
        &__password
            left: 20px
        &__eye
            right: 13px
            cursor: pointer
            path
                stroke: none
        &.is-active
            path
                fill: $color--blue

</style>